export default { sha: '47e92231679c89440fe2a17165edf77d7ddf5d91', buildNumber: 'undefined' }
